// extracted by mini-css-extract-plugin
var _1 = "CommentResultCard-module__animateUploadProgressBarWidth--AHgjt";
var _2 = "CommentResultCard-module__animatedBackground--fwTV4";
var _3 = "CommentResultCard-module__avatarContainer--WWFPI";
var _4 = "CommentResultCard-module__comment--_JqIg";
var _5 = "CommentResultCard-module__context--kZTi6";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "avatarContainer", _4 as "comment", _5 as "context" }
